<div class="h-full min-h-0 flex flex-row gap-4 w-full">
  <aside
    class="w-1/3 min-w-0 min-h-0 flex flex-col rounded-xl border border-zinc-200 bg-white shadow-sm dark:border-zinc-800 dark:bg-zinc-950">
    <div class="shrink-0 p-3 border-b border-zinc-200 dark:border-zinc-800">
      <div class="grid grid-cols-1">
        <input
          id="brief-insights-search"
          type="search"
          autocomplete="off"
          placeholder="Search briefs…"
          class="col-start-1 row-start-1 block w-full rounded-lg py-2 pr-3 pl-10 text-sm text-primary input-primary-icon"
          [value]="searchQuery()"
          (input)="onSearchInput($any($event.target).value)" />
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          class="pointer-events-none col-start-1 row-start-1 ml-3 size-5 self-center text-secondary sm:size-4"
          aria-hidden="true">
          <path d="m21 21-4.34-4.34" />
          <circle cx="11" cy="11" r="8" />
        </svg>
      </div>
      <p class="mt-2 text-xs text-secondary m-0">
        {{ (allBriefs() ?? []).length }} brief{{ (allBriefs() ?? []).length === 1 ? '' : 's' }}
        @if (searchQuery().trim()) {
          <span class="text-primary"> matching "{{ searchQuery().trim() }}"</span>
        } @else {
          <span> loaded</span>
        }
      </p>
    </div>

    <div class="flex-1 min-h-0 overflow-y-auto p-2 scrollbar-transparent" (scroll)="onListScroll($event)">
      @if (allBriefs() === undefined) {
        <p class="px-2 py-6 text-center text-sm text-secondary m-0">Loading briefs…</p>
      } @else if ((allBriefs() ?? []).length === 0 && !briefsLoading()) {
        <p class="px-2 py-6 text-center text-sm text-secondary m-0">No briefs match your search.</p>
      } @else {
        @if (briefsLoading()) {
          <p class="px-2 pb-2 text-center text-xs text-secondary m-0">Updating…</p>
        }
        <ul class="flex flex-col gap-1" role="listbox" aria-label="Briefs">
          @for (brief of allBriefs() ?? []; track brief.id) {
            <li
              role="option" class="rounded-lg border border-zinc-200 dark:border-zinc-800"
              [attr.aria-selected]="isSelectedBrief(brief)">
              <div
                class="group flex w-full min-w-0 flex-row items-center gap-3 rounded-lg border px-3 py-2.5 transition-colors cursor-pointer"
                [class]="
                  isSelectedBrief(brief)
                    ? 'border-primary/50 bg-primary/10 ring-1 ring-primary/35 dark:border-primary/45 dark:bg-primary/15 dark:ring-primary/25'
                    : 'border-transparent hover:border-zinc-200 hover:bg-zinc-50 dark:hover:border-zinc-700 dark:hover:bg-zinc-900/80'
                "
                (click)="onBriefSelect(brief)">
                <div
                  class="shrink-0 size-10 overflow-hidden rounded-lg bg-zinc-100 ring-1 ring-zinc-200/80 dark:bg-zinc-800 dark:ring-zinc-700 flex items-center justify-center">
                  @if (brief.businessAccount?.companyLogo) {
                    <img
                      [src]="imageService.getImageSource(brief.businessAccount!.companyLogo, 'gallery')"
                      alt=""
                      class="size-full object-cover" />
                  } @else {
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      class="text-secondary"
                      aria-hidden="true">
                      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                      <path d="M14 2v6h6" />
                    </svg>
                  }
                </div>
                <div class="flex min-w-0 flex-1 flex-col gap-0.5">
                  <p class="truncate text-sm font-medium text-primary leading-snug m-0">
                    {{ brief.title }}
                  </p>
                  <p class="truncate text-xs text-secondary m-0">{{ briefSubtitle(brief) }}</p>
                  <p class="text-xs text-secondary m-0">{{ timeSinceCreated(brief.createdDate) }}</p>
                </div>
                @if (brief.brief_audience === 'shout_plus') {
                  <div class="w-16 shrink-0">
                    <img
                      src="assets/images/plus/SHOUT_plus_logo_full_colour_black_regular.png"
                      alt="SHOUT+"
                      class="w-full h-auto"
                      [class.hidden]="themeService.isDarkMode()" />
                    <img
                      src="assets/images/plus/SHOUT_plus_logo_white_regular.png"
                      alt="SHOUT+"
                      class="w-full h-auto"
                      [class.hidden]="!themeService.isDarkMode()" />
                  </div>
                }
              </div>
            </li>
          }
        </ul>
        @if (briefsLoadingMore()) {
          <p class="py-3 text-center text-xs text-secondary m-0">Loading more briefs…</p>
        }
      }
    </div>
  </aside>

  <section class="flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden h-full">
    @if (!selectedBriefId()) {
      <div
        class="flex flex-1 min-h-0 min-w-0 items-center justify-center rounded-xl border border-dashed border-zinc-300 bg-zinc-50/50 p-6 dark:border-zinc-700 dark:bg-zinc-900/30">
        <app-empty-state
          title="No brief selected"
          description="Select a brief from the list to view its insights." />
      </div>
    } @else {
      <router-outlet />
    }
  </section>
</div>
